import { discountInOutflowValue } from 'reactApp/appHelpers/featuresHelpers/features/discountInOutflow';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';

import { BuyNotifications } from './buySubscription.types';

export const showSetDiscountOutflowSuccesSnackbar = () =>
    showSnackbarAction({
        text: `Постоянная скидка ${discountInOutflowValue}% активирована`,
        type: SnackbarTypes.success,
        id: BuyNotifications.setDiscountInOutflowSuccess,
        closable: true,
    });

export const showSetDiscountOutflowFailureSnackbar = () =>
    showSnackbarAction({
        text: `Не удалось активировать скидку ${discountInOutflowValue}%`,
        type: SnackbarTypes.failure,
        id: BuyNotifications.setDiscountInOutflowFailure,
        closable: true,
    });
